// extracted by mini-css-extract-plugin
module.exports = {"outer":"main-module--outer--1fvRC","box":"main-module--box--3kJoC","post":"main-module--post--2L7-h"};